// Реестр стартовых экранов для раннего preload (LCP).
// Ключ — имя первого шага конфига (configToApply[0].name).
//   load — прогрев lazy-чанка стартовой страницы (тот же модуль, что в
//          stepsComponents — webpack дедупит в один чанк).
//   hero / heroDark — мобильная LCP-картинка (.avif) для <link rel="preload">.
// При добавлении новой стартовой страницы добавь сюда одну запись.

// Карусельные экраны: hero = первый слайд (index 0).
import startPageV4Hero from '../steps/start/startPageV4/img/img1.avif';
import startPageV4HeroDark from '../steps/start/startPageV4/img/img1Dark.avif';
import startPageV44Hero from '../steps/start/startPageV44/img/img1.avif';

// bg-pattern экраны: на мобиле (window.innerWidth < 768 → dImg=false)
// рендерится ветка <img src={bg}> → мобильный hero = bg.avif.
// heroDesktop — вариант той же картинки для dImg=true (innerWidth >= 768):
// prerenderFirstScreen подменяет им srcset статичного shell'а pre-paint.
import bgV29 from '../steps/start/startPageV29/img/bg.avif';
import bgBigV29 from '../steps/start/startPageV29/img/bgBig.avif';
import bgV30 from '../steps/start/startPageV30/img/bg.avif';
import bgBigV30 from '../steps/start/startPageV30/img/bgBig.avif';
import bgV31 from '../steps/start/startPageV31/img/bg.avif';
import bgBigV31 from '../steps/start/startPageV31/img/bgBig.avif';
import bgV32 from '../steps/start/startPageV32/img/bg.avif';
import bgBigV32 from '../steps/start/startPageV32/img/bgBig.avif';
import bgV33 from '../steps/start/startPageV33/img/bg.avif';
import bgBigV33 from '../steps/start/startPageV33/img/bgBig.avif';
import bgV34 from '../steps/start/startPageV34/img/bg.avif';
import bgBigV34 from '../steps/start/startPageV34/img/bgBig.avif';
import bgV35 from '../steps/start/startPageV35/img/bg.avif';
import bgBigV35 from '../steps/start/startPageV35/img/bgBig.avif';
import bgV36 from '../steps/start/startPageV36/img/bg.avif';
import bgBigV36 from '../steps/start/startPageV36/img/bgBig.avif';
import bgV37 from '../steps/start/startPageV37/img/bg.avif';
import bgBigV37 from '../steps/start/startPageV37/img/bgBig.avif';
import bgV38 from '../steps/start/startPageV38/img/bg.avif';
import bgBigV38 from '../steps/start/startPageV38/img/bgBig.avif';
import bgV39 from '../steps/start/startPageV39/img/bg.avif';
import bgBigV39 from '../steps/start/startPageV39/img/bgBig.avif';
import bgV40 from '../steps/start/startPageV40/img/bg.avif';
import bgBigV40 from '../steps/start/startPageV40/img/bgBig.avif';
import bgV41 from '../steps/start/startPageV41/img/bg.avif';
import bgBigV41 from '../steps/start/startPageV41/img/bgBig.avif';
import bgV42 from '../steps/start/startPageV42/img/bg.avif';
import bgBigV42 from '../steps/start/startPageV42/img/bgBig.avif';
import bgV43 from '../steps/start/startPageV43/img/bg.avif';
import bgBigV43 from '../steps/start/startPageV43/img/bgBig.avif';
import bgV45 from '../steps/start/startPageV45/img/bg.avif';
import bgBigV45 from '../steps/start/startPageV45/img/bgBig.avif';
import bgV46 from '../steps/start/startPageV46/img/bg.avif';
import bgBigV46 from '../steps/start/startPageV46/img/bgBig.avif';

export type StartScreen = {
  load: () => Promise<unknown>;
  hero?: string;
  heroDark?: string;
  heroDesktop?: string;
};

export const startScreens: Record<string, StartScreen> = {
  customV2_startPageV4: {
    load: () => import('../steps/start/startPageV4'),
    hero: startPageV4Hero,
    heroDark: startPageV4HeroDark,
  },
  customV2_startPageV44: {
    load: () => import('../steps/start/startPageV44'),
    hero: startPageV44Hero,
  },
  customV2_startPageV29: { load: () => import('../steps/start/startPageV29'), hero: bgV29, heroDesktop: bgBigV29 },
  customV2_startPageV30: { load: () => import('../steps/start/startPageV30'), hero: bgV30, heroDesktop: bgBigV30 },
  customV2_startPageV31: { load: () => import('../steps/start/startPageV31'), hero: bgV31, heroDesktop: bgBigV31 },
  customV2_startPageV32: { load: () => import('../steps/start/startPageV32'), hero: bgV32, heroDesktop: bgBigV32 },
  customV2_startPageV33: { load: () => import('../steps/start/startPageV33'), hero: bgV33, heroDesktop: bgBigV33 },
  customV2_startPageV34: { load: () => import('../steps/start/startPageV34'), hero: bgV34, heroDesktop: bgBigV34 },
  customV2_startPageV35: { load: () => import('../steps/start/startPageV35'), hero: bgV35, heroDesktop: bgBigV35 },
  customV2_startPageV36: { load: () => import('../steps/start/startPageV36'), hero: bgV36, heroDesktop: bgBigV36 },
  customV2_startPageV37: { load: () => import('../steps/start/startPageV37'), hero: bgV37, heroDesktop: bgBigV37 },
  customV2_startPageV38: { load: () => import('../steps/start/startPageV38'), hero: bgV38, heroDesktop: bgBigV38 },
  customV2_startPageV39: { load: () => import('../steps/start/startPageV39'), hero: bgV39, heroDesktop: bgBigV39 },
  customV2_startPageV40: { load: () => import('../steps/start/startPageV40'), hero: bgV40, heroDesktop: bgBigV40 },
  customV2_startPageV41: { load: () => import('../steps/start/startPageV41'), hero: bgV41, heroDesktop: bgBigV41 },
  customV2_startPageV42: { load: () => import('../steps/start/startPageV42'), hero: bgV42, heroDesktop: bgBigV42 },
  customV2_startPageV43: { load: () => import('../steps/start/startPageV43'), hero: bgV43, heroDesktop: bgBigV43 },
  customV2_startPageV45: { load: () => import('../steps/start/startPageV45'), hero: bgV45, heroDesktop: bgBigV45 },
  customV2_startPageV46: { load: () => import('../steps/start/startPageV46'), hero: bgV46, heroDesktop: bgBigV46 },
  start_page_age: { load: () => import('../steps/start/startPageAge') },
};
